/* eslint no-shadow:0 */

const data = {
  motor_base_url: process.env.VUE_APP_MOTOR_BASE_URL,
};
const getters = {
  getMotorBaseUrl: (state) => state.motor_base_url,
};

export default { namespaced: true, state: data, getters };
